import React, { useRef, useState } from "react";
import "./LatestBlogsSection.css";
import { FaChevronLeft, FaChevronRight, FaPlay } from "react-icons/fa";

const videos = [
  {
    id: 1,
    category: "Overview",
    title: "How KrivaONE Protects Your Privacy",
    image: "/video1-thumb.png",
    video: "/KrivaOne1stEnglish.mp4",
  },
  {
    id: 2,
    category: "Communication",
    title: "Using Your Private Communication ID",
    image: "/video2-thumb.png",
    video: "/videos/video2.mp4",
  },
];

export default function LatestVideosSection() {
  const sliderRef = useRef();
  const [playingId, setPlayingId] = useState(null);

  const scroll = (dir) => {
    sliderRef.current.scrollBy({
      left: dir === "left" ? -350 : 350,
      behavior: "smooth"
    });
  };

  return (
    <section className="blog-section">
      <div className="blog-header">
        <div>
          <span className="blog-subtitle">
            Watch & Learn
          </span>
          <h2 className="blackcolor">
            See KrivaONE
            <span> In Action</span>
          </h2>
        </div>
        <div className="blog-nav">
          <button onClick={() => scroll("left")}>
            <FaChevronLeft />
          </button>
          <button onClick={() => scroll("right")}>
            <FaChevronRight />
          </button>
        </div>
      </div>

      <div className="blog-slider" ref={sliderRef}>
  {videos.map(item => (
    <div className="blog-card1" key={item.id}>
      <div className="blog-image">
        <video
          src={item.video}
          poster={item.image}
          controls
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </div>
    </div>
  ))}
</div>
    </section>
  );
}